// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2AWyD","boxTitle":"Qualiphy_boxTitle__3x3En","box":"Qualiphy_box__1BZ_u","toggleWrap":"Qualiphy_toggleWrap__JpVnb"};